import { themeColors } from '../../themeColors';
import BackButton from "@/components/Common/BackButton";
/**
 * @file   src\components\Common\PreLauchCityRequestModal.js
 * @brief  This file is responsible for popup showing when searched location is in Pre Launch
 * @date   June, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Row, Col, Button } from "react-bootstrap";
import TextBox from "../Common/TextBox";
import { emailValidation } from "../../helpers/validations";
import { removeLocalStorage } from "../../helpers/common";
import { savePreLaunchInterest } from "../../services/userprofileService";
import { toast } from "react-toastify";

const PreLaunchCityRequestModal = (props) => {
  const { setUserLocation, userLocation, isMobileView, PreLaunchStateName } =
    props;
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  const handleEmailChange = (e) => {
    setEmailError("");
    setEmail(e.target.value);
  };
  const validate = (mail) => {
    let isValid = true;
    setEmailError("");
    if (mail.trim() === "") {
      isValid = false;
      setEmailError("Enter Email");
    } else if (!emailValidation(mail.trim())) {
      isValid = false;
      setEmailError("Enter Valid email");
    }
    return isValid;
  };

  const handleCancel = () => {
    setEmailError("");
    removeLocalStorage("searchedLocation");
    setUserLocation(null);
    setEmail("");
    props.onHide();
  };

  const handleSubmit = async () => {
    const isValid = validate(email);
    if (isValid) {
      const payload = {
        email: email,
        city: userLocation?.city,
        state: userLocation?.state,
      };
      await savePreLaunchInterest(payload)
        .then((response) => {
          if (response.errorCode === 0) {
            toast.success(response?.message);
            removeLocalStorage("searchedLocation");
            setUserLocation(null);
            props.onHide();
          } else {
            toast.error(response.message);
          }
        })
        .catch((error) => {
          toast.error(error);
        });
    }
  };

  return (
    <>
      <Modal
        show
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-settings"
        backdrop="static"
      >
        <Modal.Body className="pt-32 pb-32 modalPadding">
          {isMobileView ? (
            ""
          ) : (
            <BackButton onClick={handleCancel} />
          )}
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handleCancel}
          ></button>
          {isMobileView ? (
            <>
              <h4 className="text-center mt-4 fntModalHead-mob">
                {PreLaunchStateName} Agents, <br />
                get ready and tell your friends...
                <br />
                The Buyer Listing Service
                <sup className="trademark-symbol-mob ">®</sup> <br /> is
                launching soon! 🚀
              </h4>
              <p className="f-size-16 mb-4 pt-3 text-center">
                Would you like to access to our pre-launch? We’re providing an
                exclusive concierge service to a select group of early adopters
                & top teams in the area. Enter your email if you’re interested:
              </p>
            </>
          ) : (
            <>
              <h4 className="text-start mt-4 fntModalHead">
                {PreLaunchStateName} Agents, get ready and tell your friends...
                <br />
                The Buyer Listing Service
                <sup className="trademark-symbol-mob ">®</sup> is launching
                soon! 🚀
              </h4>
              <p className="f-size-16 mb-4   text-start">
                Would you like to access to our pre-launch? We’re providing an
                exclusive concierge service to a select group of early adopters
                & top teams in the area. Enter your email if you’re interested:
              </p>
            </>
          )}
          <Row>
            <Col xl={12}>
              <div className="textbox-wrap mb-3 mb-sm-3">
                <TextBox
                  id="mailId"
                  name="emailId"
                  value={email}
                  type="email"
                  placeholder="Email address"
                  className="form-control"
                  onChange={(e) => handleEmailChange(e)}
                  errorClass="error-validation-msg"
                  errorMessage={emailError}
                />
              </div>
            </Col>
          </Row>

          <div className="modal-btn-wrap">
            <Button
              variant=""
              className={
                isMobileView
                  ? "btn btn-primary btnPadding-mob"
                  : "btn btn-primary mt-2"
              }
              onClick={() => handleSubmit()}
            >
              Submit
            </Button>
            {isMobileView ? (
              <button
                type="button"
                onClick={() => handleCancel()}
                className="btn btn-no-bg btn-no-bg-fix btn-no-bg-black"
              >
                Back
              </button>
            ) : (
              <></>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default PreLaunchCityRequestModal;
